import { render, staticRenderFns } from "./ClientsSettingsAmSupervisor.vue?vue&type=template&id=0639d603&"
import script from "./ClientsSettingsAmSupervisor.vue?vue&type=script&lang=js&"
export * from "./ClientsSettingsAmSupervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports